.container {
  border-radius: 10px;
  background: linear-gradient(270deg, rgba(182, 75, 248, 0.2) 0%, rgba(1, 121, 207, 0.2) 100%), var(--default-bg);
  display: flex;
  gap: 20px;
  margin-top: 30px;
  padding: 25px;
  width: 100%;
}

.text {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.heading {
  align-items: center;
  display: flex;
  gap: 10px;
}

.pill {
  border-radius: 16px;
  background: #e43cd5;
  padding: 2px 6px;
}
